// extracted by mini-css-extract-plugin
export default {"_":"buttonBuyOneClick____hByV3","text1":"buttonBuyOneClick_text1__r4gLF","text2":"buttonBuyOneClick_text2__uzMLD"};